<template>
  <div class="home-div">
    <!-- 搜索框 -->
    <div class="search-bar">
      <HomeSearch :isPreview="true" />
    </div>

    <!-- 类目Tag栏目 -->
    <div class="tab-max-div">
      <van-tabs :active="tabSld" sticky @change="tabChangeFn">
        <van-tab :name="0" title="ALL" />
        <van-tab v-for="item in useWapCategory().value" :key="item.id" :name="item.id" :title="item.name" />
      </van-tabs>
    </div>

    <div class="tab-item-view" v-show="tabSld === 0">
      <div v-for="(item, idx) in homeConfigData" :key="idx">
        <!-- 轮播图Banner -->
        <div class="wh-card" v-if="item.type === 'adv_list'">
          <WHomeBanner :data="item.value" :priority="priorityVisualIndexes.includes(idx)" :eager="priorityVisualIndexes.includes(idx)" track-home-banner-source />
        </div>
        <!-- 金刚区Icon -->
        <div class="wh-card" v-if="item.type === 'icon_list' && item.value.item?.length > 0">
          <WHomeIconList :data="item.value.item" track-home-icon-source />
        </div>
          <!-- 秒杀 -->
        <div class="wh-card" v-if="item.type === 'flash_sale' && !hiddenFlashSale">
          <WHomeFlashSale @no-data="hiddenFlashSale = true" />
        </div>

        <div class="wh-card" v-if="item.type === 'cut_image'">
          <WHomeCutImage :data="item.value" :priority="priorityVisualIndexes.includes(idx)" :eager="priorityVisualIndexes.includes(idx)" track-home-banner-source />
        </div>

      </div>

      <ClientOnly>
        <KViewportMount><LazyKRecommendProduct :recommend-id="1" /></KViewportMount>

        <template #fallback>
          <div class="lazy-loading"><van-loading size="40px" color="#DD3131" type="spinner" /></div>
        </template>
      </ClientOnly>
    </div>

    <div v-if="categoryVisited" v-show="tabSld !== 0" class="tab-wrapper">
      <ClientOnly>
        <div class="ctgs">
          <LazyKFrontCategorys
            :rowTotal="2"
            category-traffic-type="hotCategory"
            :category-list="curTab?.children || []"
            @update:cid="handleCtgClick"
          />
        </div>

        <van-list
          :loading="curTab?.loading"
          :finished="curTab?.finished"
          finished-text="no more"
          loading-text="loading..."
          :immediate-check="false"
          :offset="300"
          @load="handleListLoadChange"
        >
          <KProductList :product-list="curTab?.listings || []" />
        </van-list>

        <template #fallback>
          <div class="lazy-loading"><van-loading size="40px" color="#DD3131" type="spinner" /></div>
        </template>
      </ClientOnly>
    </div>
    
    <!-- 底部菜单 -->
    <KTabbar />
  </div>

  <LazyKCookiePopup />

  <ClientOnly>
    <div class="app-download-bar" v-if="showAppDownloadBar">
      <div class="app-download-bar-inner">
        <div class="app-download-info">
          <img class="app-logo" src="/imgs/icon_48.png" alt="Kilimall" />
          <div class="app-detail">
            <div class="app-title-row">
              <span class="app-title">Kilimall - Affordable & Safe Shopping</span>
              <span class="app-close" @click="closeAppDownloadBar"><van-icon name="cross" /></span>
            </div>
            <div class="app-rating">
              <van-rate :model-value="4.8" allow-half readonly size="12" color="#F9BE00" void-color="#F9BE00" />
              <span class="rating-text">4.8+</span>
            </div>
            <p class="app-desc">Exclusive offers, best deals and real-time order tracking — all in one place.</p>
          </div>
        </div>
        <a class="app-download-btn" href="https://kilimall.go.link?adj_t=1wqsvs0u" target="_blank">Download the APP</a>
      </div>
    </div>
  </ClientOnly>
  
  <!-- 性能监控组件 (仅开发环境) -->
  <!-- <ClientOnly>
    <PerformanceMonitor v-if="isDev" />
  </ClientOnly> -->
</template>
<script setup lang="ts">
import { getHomeConfig, getHotFrontCtgs } from '@/api/models/home'
import { search, type ISearchParams } from '@/api/models/system'
import { setWebSite } from './home.website'
import WHomeCutImage from './wap-widgets/CutImage.vue'
import WHomeFlashSale from './wap-widgets/FlashSale.vue'
// 关键首屏组件 - 同步加载
import WHomeBanner from './wap-widgets/Banner.vue';
import WHomeIconList from './wap-widgets/IconList.vue'
import { buildCategoryNavigationSource, jumpCategoryBindUrl } from '~/plugins/utils'

// 非关键组件 - 异步加载
// const WHomeCutImage = defineAsyncComponent(() => import('./wap-widgets/CutImage.vue'))
// const WHomeFlashSale = defineAsyncComponent(() => import('./wap-widgets/FlashSale.vue'))

definePageMeta({ layout: 'wap' })
// Decide before SSR renders the wrapper; a child setup emit is too late to
// prevent an empty flash-sale card appearing and disappearing on hydration.
const hiddenFlashSale = ref(!useGlobalJsonData().value.flashsale?.data?.skus?.length)
// @ts-ignore
const { $throttle, $formatDate, $formatStringToURL, $sensorsTrack } = useNuxtApp()

const seoConfig = useGlobalJsonData().value.seo?.data
if(seoConfig?.homepage) {
  const { title: seoTitle, metaDescription, metaTitle, metaKeywords } = seoConfig.homepage
  useHead({
    title: seoTitle,
    meta: [
      { name: 'title', content: metaTitle },
      { name: 'description', content: metaDescription },
      { name: 'keywords', content: metaKeywords }
    ]
  })
}

setWebSite()

const router = useRouter()
const { $getCountry } = useNuxtApp()

/** tab栏相关 */
const initTagsList = async(type: 'refresh' | 'load') => {
  if(!curTab.value) {
    return
  }

  curTab.value.loading = true

  const { skip, size, frontCategoryId } = curTab.value
  const p: ISearchParams = { skip, size, frontCategoryId }
  const res = await search(p)
  const { result } = res
  curTab.value.algorithmModelName = res.algorithmModelName || ''

  curTab.value.skip += curTab.value.size
  curTab.value.finished = result.length < curTab.value.size
  result.forEach((c: any) => {
    // 热门类目商品跳转详情来源
    c.source = buildCategoryNavigationSource('hotCategory', curTab.value?.name || '', 'hotCategoryFragment')
    c.algorithmModelName = res.algorithmModelName || ''
  })
  if(type === 'refresh') {
    curTab.value.listings = result || []
  } else {
    curTab.value.listings.push(...result)
  }

  curTab.value.loading = false
}

const handleListLoadChange = async() => {
  if(!curTab.value || curTab.value.loading) { return }

  await initTagsList('load')
}

/** 切换tab栏事件 */
const tabSld = ref<any>(0)
const curTab = ref<IHomeCategory>()
const categoryVisited = ref(false)
const tabChangeFn = async(name: number, title: string) => {
  tabSld.value = name
  if(name === 0 ) { return }

  curTab.value = useWapCategory().value.find((c) => c.id === name)
  if(!curTab.value) { return }
  categoryVisited.value = true
  
  useRequestLoading().value = true
  
  if(curTab.value && curTab.value.bindUrl) {
    jumpCategoryBindUrl(curTab.value.bindUrl, 'hotCategory', curTab.value.name || title)
    return
  }

  if(process.client) { window.scrollTo(0, 0) }

  curTab.value.frontCategoryId = name as number
  
  const fns = []

  if(curTab.value.listings.length <= 0) {
    curTab.value.loading = false
    curTab.value.finished = false
    curTab.value.skip = 0
    fns.push({ fn: initTagsList, p: 'refresh' })
  }
  
  await Promise.all(fns.map(({ fn, p }) => fn(p as never))).finally(() => {
    curTab.value!.loading = false

    useRequestLoading().value = false
  })

  // 搜索B埋点
  const { searchEventFn } = await import('@/plugins/bi-sa.client')
  const saBiParams: Parameters<typeof searchEventFn>[0] = {
    internal_latest_traffic_source_module: 'searchCategory',
    internal_latest_traffic_source_type: 'hotCategory',
    inside_latest_traffic_source_value: title || '',
    is_has_result: curTab.value ? curTab.value.length > 0 : false ,
    result_nums: curTab.value?.length || 0,
    is_has_filter: false,
    sort_type: 'bestMatch',
    algorithm_model_name: curTab.value?.algorithmModelName || ''
  }
  searchEventFn(saBiParams, $sensorsTrack)
}

const handleCtgClick = (id: number, cname: string) => {
  const source = buildCategoryNavigationSource('hotCategory', cname)
  router.push(`/category/${$formatStringToURL(cname)}?id=${id}&form=category-hot&source=${encodeURIComponent(source)}`)
}

const onScroll = $throttle((ev: Event) => {
  if(document.documentElement.scrollTop > (document.body.offsetHeight / 2)) {
    usePWAPromptPopup().value = true

    window.removeEventListener('scroll', onScroll)
  }
}, 20)

/** 首页配置项初始化 */
const homeConfigData = ref<any>([])
// Both leading visual blocks can be in the first viewport. Icons and an empty
// flash-sale slot must not turn the measured cut-image LCP into a lazy request.
const priorityVisualIndexes = computed<number[]>(() => homeConfigData.value
  .flatMap((item: any, index: number) => item.type === 'cut_image' || item.type === 'adv_list' ? [index] : [])
  .slice(0, 2))
const homeConfigInitFn = (config?: any) => {
  const homeConfig = config || useHomeConfig().value;

  (homeConfig || []).forEach((item: any) => {
    const key: string = Object.keys(item)[0]

    homeConfigData.value.push({ type: key, value: item[key] })
  })
}

const applyWapCategories = (categories: any[]) => {
  const previous = useWapCategory().value
  useWapCategory().value = categories.map((category): IHomeCategory => {
    const existing = previous.find(item => item.id === category.id)
    const state = {
      finished: existing?.finished ?? false,
      loading: existing?.loading ?? false,
      frontCategoryId: existing?.frontCategoryId ?? 0,
      skip: existing?.skip ?? 0,
      size: existing?.size ?? 16,
      listings: existing?.listings ?? []
    }
    // Preserve the active category reference and its visited list if the cached
    // category JSON finishes loading after the user's first click.
    return Object.assign(existing || {}, category, state) as IHomeCategory
  })
}
const initWapCtgs = async () => {
  try {
    const frontCtgs = await getHotFrontCtgs()
    if (frontCtgs?.length) applyWapCategories(frontCtgs)
  } catch {
    console.warn('Unable to refresh categories; keeping the server-rendered categories')
  }
}

if(process.server) {
  applyWapCategories(useGlobalJsonData().value.hot_categories?.data || [])
}
try {
  if(useHomeConfig().value?.length > 0) {
    homeConfigInitFn()
  } else {
    const res = await getHomeConfig()

    if(res) {
      useHomeConfig().value = res

      homeConfigInitFn(res)
    }
  }
} catch(e) {
  console.error(e)
}


/** 首页底部App下载引导条 */
const showAppDownloadBar = ref(false)
const closeAppDownloadBar = () => {
  showAppDownloadBar.value = false
  // 已登录用户关闭后记录日期，当天不再弹出
  if (useUserInfo().value?.accessToken) {
    localStorage.setItem('home_app_download_bar_time', $formatDate(new Date(), 'yyyyMMdd'))
  }
}
const initAppDownloadBar = () => {
  if (isFacebook().value || isTiktok().value || isWhatsApp().value) return

  const isLoggedIn = !!useUserInfo().value?.accessToken
  if (isLoggedIn) {
    // 已登录：每天弹一次
    const lastTime = localStorage.getItem('home_app_download_bar_time')
    const curTime = $formatDate(new Date(), 'yyyyMMdd')
    showAppDownloadBar.value = lastTime !== curTime
  } else {
    // 未登录：浏览器会话期间只弹一次
    if (!sessionStorage.getItem('home_app_download_bar_shown')) {
      showAppDownloadBar.value = true
      sessionStorage.setItem('home_app_download_bar_shown', '1')
    }
  }
}

onMounted(async () => {
  const curTime = $formatDate(new Date(), 'yyyyMMdd')
  const lastPopupTime = localStorage.getItem('pwa_popup_time')

  if(lastPopupTime !== curTime && useIsMobile().value) {
    window.addEventListener('scroll', onScroll)
  }

  initAppDownloadBar()

  await nextTick()
  await initWapCtgs()
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>
<style lang='scss' scoped>
.lazy-loading{
  padding: 30px 0;
  text-align: center;
}
.wh-card{
  margin: 16px 0;
}
.tab-max-div{
  min-height: var(--van-tabs-line-height, 44px);
  position: sticky;
  top: 82px;
  z-index: 9;
}
.home-div {
  width: 100%;
  box-sizing: border-box;
  min-height: 100vh;
  .tab-item-view {
    // width: 100vw;
    padding: 0 16px;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
  }
}
.loading-data-div {
  text-align: center;
  padding-top: 88px;

}
.search-bar{
  position: sticky;
  top: 0;
  background-color: #fff;
  height: 90px;
  z-index: 101;
}
.app-download-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: linear-gradient(180deg, #FFDEDE 0%, #FFF 100%);
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 24px 24px 0 0;
  padding: 24px 24px 20px;

  .app-download-bar-inner {
    display: flex;
    flex-direction: column;
  }
  .app-download-info {
    display: flex;
    align-items: flex-start;
  }
  .app-logo {
    width: 102px;
    height: 102px;
    min-width: 102px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .app-detail {
    flex: 1;
    margin-left: 20px;
    overflow: hidden;
  }
  .app-title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .app-title {
    font-size: 28px;
    font-weight: 400;
    color: #150000;
    line-height: 1.3;
    flex: 1;
  }
  .app-close {
    margin-left: 16px;
    color: #999;
    font-size: 32px;
    cursor: pointer;
    flex-shrink: 0;
  }
  .app-rating {
    display: flex;
    align-items: center;
    margin-top: 8px;
    .rating-text {
      margin-left: 8px;
      font-size: 24px;
      color: #666666;
    }
  }
  .app-desc {
    margin-top: 8px;
    font-size: 24px;
    color: #666;
    line-height: 1.4;
    font-weight: 400;
  }
  .app-download-btn {
    display: block;
    width: 600px;
    height: 68px;
    line-height: 68px;
    margin: 20px auto 0;
    text-align: center;
    background: var(---2, #E14646);
    color: #fff;
    font-size: 32px;
    font-weight: 600;
    text-decoration: none;
    border-radius: 8px;
  }
}
</style>
